import { css } from "styled-components";

import { ButtonVariantTypes } from "components/constants";
import {
  getCustomHoverColor,
  getCustomBackgroundColor,
} from "widgets/WidgetUtils";
import type { ButtonContainerProps } from "./DragContainer";

/*
  Created a css util so that we don't repeat our styles.
  Add more styles in the future also make sure you pass the
  same props to the ButtonContainerProps, because we have to
  repeat on the button and the container.
*/

export const buttonHoverActiveStyles = css<ButtonContainerProps>`
  ${({
    buttonBackgroundImage,
    buttonColor,
    buttonVariant,
    disabled,
    isScreen,
    loading,
    theme,
  }) => {
    if (buttonBackgroundImage) {
      return `
        background: url('${buttonBackgroundImage}') no-repeat center top / 100% 100% !important;
        textShadow: 1px 1px 1px ${getCustomHoverColor(
          theme,
          buttonVariant,
          buttonColor,
        )};
      `;
    }
    if (!disabled && !loading) {
      if (isScreen) {
        return `
          background: "transparent";
          textShadow: 1px 1px 1px ${getCustomHoverColor(
            theme,
            buttonVariant,
            buttonColor,
          )};
          borderColor: "#ffffff";
        `;
      }
      return `
        background: ${
          getCustomHoverColor(theme, buttonVariant, buttonColor) !== "none"
            ? getCustomHoverColor(theme, buttonVariant, buttonColor)
            : buttonVariant === ButtonVariantTypes.SECONDARY
              ? theme.colors.button.primary.secondary.hoverColor
              : buttonVariant === ButtonVariantTypes.TERTIARY
                ? theme.colors.button.primary.tertiary.hoverColor
                : theme.colors.button.primary.primary.hoverColor
        } !important;
      `;
    }
  }}
`;

export const buttonStyle = css<ButtonContainerProps>`
  ${({
    buttonBackgroundImage,
    buttonColor,
    buttonVariant,
    isScreen,
    theme,
  }) => {
    if (buttonBackgroundImage) {
      return `
        background: url('${buttonBackgroundImage}') no-repeat center top / 100% 100% !important;
      `;
    }
    return `
      background: ${
        getCustomBackgroundColor(buttonVariant, buttonColor) !== "none"
          ? getCustomBackgroundColor(buttonVariant, buttonColor)
          : buttonVariant === ButtonVariantTypes.PRIMARY
            ? theme.colors.button.primary.primary.bgColor
            : "none"
      } !important;
    `;
  }}
`;
